export const WHATSAPP_NUMBER = "+33 7 75 83 69 68";
export const WHATSAPP_INTL = "33775836968";

export function waLink(message) {
  return `https://wa.me/${WHATSAPP_INTL}${
    message ? `?text=${encodeURIComponent(message)}` : ""
  }`;
}

export function productWaLink(product) {
  return waLink(
    `Bonjour Zuliany, je suis intéressé(e) par la pièce « ${product.brand} ${product.name} ». Est-elle toujours disponible ?`
  );
}

export const CATEGORIES = [
  { id: "echarpe", label: "Écharpes" },
  { id: "maroquinerie", label: "Maroquinerie" },
  { id: "chaussures", label: "Chaussures" },
  { id: "vestiaire", label: "Vestiaire" },
];

export const STATUS = {
  available: { label: "Disponible", badge: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30" },
  reserved: { label: "Réservé", badge: "bg-amber-500/15 text-amber-400 border-amber-500/30" },
  sold: { label: "Vendu", badge: "bg-zinc-500/15 text-zinc-400 border-zinc-500/30" },
};

export function formatPrice(price) {
  return new Intl.NumberFormat("fr-FR", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: 0,
  }).format(price);
}

const COLOR_HEX = {
  noir: "#141414",
  blanc: "#FFFFFF",
  ivoire: "#F5EFE0",
  ecru: "#EDE6D6",
  creme: "#F5EFE0",
  beige: "#E3D5C3",
  taupe: "#A89485",
  camel: "#B08968",
  marron: "#6B4F3A",
  brun: "#5D4632",
  monogram: "#7A6A58",
  monogramme: "#7A6A58",
  gris: "#9CA3AF",
  "gris clair": "#D1D5DB",
  "gris fonce": "#4B4B52",
  anthracite: "#3F3F46",
  argente: "#C0C0C0",
  argent: "#C0C0C0",
  rose: "#F0A3BC",
  "rose poudre": "#EFC8CE",
  "rose fonce": "#D63384",
  fuchsia: "#D63384",
  bordeaux: "#6E1423",
  rouge: "#C22F2F",
  orange: "#E37E00",
  jaune: "#F0C33C",
  or: "#D4AF37",
  dore: "#D4AF37",
  vert: "#2E7D4F",
  kaki: "#6B6B4A",
  "vert amande": "#8FBF8F",
  bleu: "#2B5AA7",
  "bleu marine": "#1B2A4A",
  marine: "#1B2A4A",
  "bleu ciel": "#9DC3E6",
  turquoise: "#3FB8C4",
  lilas: "#B49BD6",
  violet: "#7C4DB8",
  mauve: "#B39BC8",
};

export function colorHex(name) {
  const k = (name || "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
  return COLOR_HEX[k] || "#B8B0A6";
}

const BRAND_STYLES = {
  "louis vuitton": { bg: "#4B3A2F", mono: "LV" },
  lv: { bg: "#4B3A2F", mono: "LV" },
  gucci: { bg: "#1F3A2D", mono: "GUCCI" },
  hermes: { bg: "#E37E00", mono: "H" },
  chanel: { bg: "#0A0A0B", mono: "CC" },
  "saint laurent": { bg: "#0A0A0B", mono: "SL" },
  dior: { bg: "#2B2B33", mono: "CD" },
  prada: { bg: "#1E3A34", mono: "PRADA" },
  fendi: { bg: "#2B211C", mono: "FF" },
  celine: { bg: "#6E4F35", mono: "CELINE" },
  "bottega veneta": { bg: "#2E4A3B", mono: "BV" },
  loewe: { bg: "#B98A4E", mono: "LOEWE" },
};

export function brandButton(brand) {
  const k = (brand || "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
  return BRAND_STYLES[k] || null;
}
